import { __assign, __awaiter, __generator } from "tslib";
import fetcherWithRegionHeader from "../utils/fetcherWithRegionHeader";
var fetchNext = function (url) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a, nextUrl, results, _b, _c, _d;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          return [4 /*yield*/, fetcherWithRegionHeader(url)];
        case 1:
          (_a = _e.sent()),
            (nextUrl = _a.pagination.nextUrl),
            (results = _a.results);
          if (!nextUrl) return [3 /*break*/, 3];
          _d = (_c = results).concat;
          return [4 /*yield*/, fetchNext(nextUrl)];
        case 2:
          _b = _d.apply(_c, [_e.sent()]);
          return [3 /*break*/, 4];
        case 3:
          _b = results;
          _e.label = 4;
        case 4:
          return [2 /*return*/, _b];
      }
    });
  });
};
export var fetchAll = function (url, filters) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          // URLSearchParams() doesn't accept values of type number
          return [
            4 /*yield*/,
            fetchNext(
              ""
                .concat(url, "?")
                .concat(
                  new URLSearchParams(
                    __assign(__assign({}, filters), { offset: "0" })
                  )
                )
            ),
          ];
        case 1:
          // URLSearchParams() doesn't accept values of type number
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
